export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6687.044598c7.jpg";